function lazyLoadCss(href) {
  const link = document.createElement('link');
  link.css = 'text/javascript';
  link.rel = 'stylesheet';
  link.href = href;
  document.getElementsByTagName('head')[0].appendChild(link);
}

module.exports = lazyLoadCss;
